import React, { useState } from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import firebase from 'firebase/app';
import { Position,  Intent, Toaster } from "@blueprintjs/core";


const AppToaster = Toaster.create({
    className: "edited",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Template Edited", intent: Intent.PRIMARY, timeout: 1000});
}

function EditTemplateModal({
    setShowEditTempMod,
    showEditTempMod,
    editTitle,
    editTemp,
    editId,
    profile
}) {

    const [ title, setTitle ] = useState(editTitle)
    const [ temp, setTemp ] = useState(editTemp)
    // const [ pain, setPain ] = useState(editPain)


    const saveEdit = () =>{

        firebase
        .firestore()
        .collection('organizations')
        .doc(profile.company)
        .collection('valueProps')
        .doc(editId)
        .update({
            Template: temp.trim(),
            Title: title.trim()
        }).then(() =>{
            setShowEditTempMod(false)
            showToast()
        })
    }

    return (
        <Transition.Root show={showEditTempMod} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        // initialFocus={completeButtonRef}
        open={showEditTempMod}
        onClose={setShowEditTempMod}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div className="mt-1 text-left">
                  <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                    Edit Template
                  </Dialog.Title>
                  {/* <div className="mt-2 mb-4">
                      Yo
                  </div> */}
                  <div
                  className="my-3 "
                  >
                      <p className="font-semibold mb-1">
                          Title
                      </p>
                      <input 
                      className="border-2 border-gray-200 rounded-lg w-full focus:outline-none focus:ring p-2 resize"
                      defaultValue={editTitle}
                      onChange={(e) => setTitle(e.target.value)}
                      />
                  </div>
                  <div
                  className="my-2"
                  >
                      <p className="font-semibold mb-1">
                          Template
                      </p>
                      <textarea 
                      className="border-2 border-gray-200 rounded-lg w-full focus:outline-none focus:ring p-2 resize-none h-72"
                      defaultValue={editTemp}
                      onChange={(e) => setTemp(e.target.value)}
                      />
                  </div>
                
                  <div
                  className="flex"
                  >
                    <button
                    onClick={() => saveEdit()}
                    className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-800 focus:outline-none"
                    >
                        Approve Changes
                    </button>
                    <button
                    className="ml-3 p-2 rounded-lg bg-gray-600 text-white hover:bg-gray-800 focus:outline-none"
                    onClick={() => setShowEditTempMod(false)}
                    >
                        Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
    )
}

export default EditTemplateModal
